import store from '@/store'
import router from '@/router'

export default {
  install: (Vue, options) => {
    Vue.prototype.$auth = {
      login: (username, password, subdomain, userType = '') => {
        let postData = userType === 'student'
          ? { student_code: username, password, subdomain, user_type: userType }
          : { email: username, password, subdomain, user_type: userType }

        return new Promise(function(resolve, reject) {
          Vue.prototype.$http.post('/api/auth/login', postData)
            .then(async (response) => {
              localStorage.setItem('access_token', response.data.meta.access_token)
              localStorage.setItem('user', JSON.stringify(response.data.data))
              console.log(response.data.data)
              localStorage.setItem('aac', response.data.data.role === 'admin')
              localStorage.setItem('userroles', JSON.stringify(response.data.data.school_roles))
              await store.commit('UPDATE_USER', { user: response.data.data })
              await store.commit('UPDATE_TOKEN', { token: response.data.meta.access_token })
              resolve(response)
            }).catch((error) => {
              reject(error)
            })
        })
      },
      logout: async () => {
        if (store.state.user.user && store.state.user.user.role === 'normal') {
          router.push('/login')
        } else {
          router.push('/system/login')
        }
        store.commit('UPDATE_TOKEN', { token: null })
        localStorage.removeItem('access_token')
        setTimeout(() => {
          store.commit('UPDATE_USER', { user: {} })
          localStorage.removeItem('user')
        }, 1000)
      },
      forgotPassword: (email, subdomain) => {
        return new Promise(function(resolve, reject) {
          Vue.prototype.$http.post('/api/auth/forgot_password', {
            email, subdomain,
          }).then(async (response) => {
            // Redirect to reset password
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      resetPassword: (email, resetCode, password) => {
        return new Promise(function(resolve, reject) {
          Vue.prototype.$http.post('/api/auth/reset_password', {
            email, reset_code: resetCode, password,
          }).then(async (response) => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
        })
      },
    }
  },
}
